"use client";

import type { ReactNode } from "react";
import { AuthProvider } from "@/platforms/supplier/context/AuthContext";
import { SettingsProvider } from "@/platforms/supplier/context/SettingsContext";
import SupplierPerfBootstrap from "@/platforms/supplier/perf/SupplierPerfBootstrap";

/**
 * Single mount point for supplier AuthProvider + SettingsProvider.
 * Always wraps so SSR/prerender pages with DashboardLayout can call useAuth.
 * Session restore runs only on supplier routes (gated inside AuthProvider).
 */
export default function SupplierPortalShell({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <SettingsProvider>
        {children}
        <SupplierPerfBootstrap />
      </SettingsProvider>
    </AuthProvider>
  );
}

export { isSupplierPortalPath, isSupplierPortalRoute } from "./supplierPortalRoutes";
